import { parseRegExpLiteral } from 'regexpp';

/**
 * @class
 * Class designed to work with regular expressions
 */
export class RegexpFormatter {
  /**
   * @function
   * Regular expression parsing function. Returns a new regular expression
   * @param {String | RegExp} source - Regular expression to be parsed
   * @param {Object} replace - An object with a configuration to replace in the source. Takes two values "sub_string" & "new_string"
   */
  parse(source, replace = {}) {
    if (!source) {
      return new Error('Value must not be empty');
    }

    let _source = '';

    if (replace && Object.keys(replace).length > 0 && replace.sub_string && replace.new_string) {
      const { sub_string, new_string } = replace;

      _source = source.replace(sub_string, new_string);
    } else {
      _source = source;
    }

    // This check is needed in order to exclude the case when the "/" character is missing.
    // All this is related to "regexpp" dependencies, if a character is missing, an error occurs
    if (_source[0] !== '/') {
      _source = _source[_source.length - 1] === '$' ? `/${_source}/` : `/${_source}`;
    }

    const { flag, regex } = this._parseFlagAndRegex(_source);

    return new RegExp(regex, flag);
  }

  /**
   * @function
   * Regular expression parsing function to separate it from the flag. Returns a flag and a regular expression
   * @param {String | RegExp} source - Regular expression to be parsed
   */
  _parseFlagAndRegex(source) {
    const result = parseRegExpLiteral(source);

    return {
      regex: result.pattern.raw,
      flag: result.flags.raw || 'g',
    };
  }
}
